import { faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'component-library';
import advancedMenusImg from '../../../../assets/lcpIcons/advanced.png';
import listImg from '../../../../assets/lcpIcons/autolisttest-01.png';
import autoTrimImg from '../../../../assets/lcpIcons/autotrimtest-01.png';
import sensitivityImg from '../../../../assets/lcpIcons/baseline_tune_black_24dp.png';
import coTurnImg from '../../../../assets/lcpIcons/coordinatedturn-new-01.png';
import extBusImg from '../../../../assets/lcpIcons/extbus.png';
import functionSetupImg from '../../../../assets/lcpIcons/functionsetup-new-01.png';
import gpsSimImg from '../../../../assets/lcpIcons/gpsselection-new-01.png';
import interceptorImg from '../../../../assets/lcpIcons/interceptorsetup-01.png';
import nmeaSimImg from '../../../../assets/lcpIcons/NMEA-R-Blue-293-x-214-compressed 2.png';
import systemSetupImg from '../../../../assets/lcpIcons/panelsettings.png';
import rudderImg from '../../../../assets/lcpIcons/ruddersignalnew-01.png';
import sensorImg from '../../../../assets/lcpIcons/sensorsetup-01.png';
import speedImg from '../../../../assets/lcpIcons/speedsource-01.png';
import pitchImg from '../../../../assets/lcpIcons/waves-01.png';
import advancedMenusImgWhite from '../../../../assets/lcpIcons/white/advanced.png';
import listImgWhite from '../../../../assets/lcpIcons/white/autolisttest-01.png';
import autoTrimImgWhite from '../../../../assets/lcpIcons/white/autotrimtest-01.png';
import sensitivityImgWhite from '../../../../assets/lcpIcons/white/baseline_tune_black_24dp.png';
import coTurnImgWhite from '../../../../assets/lcpIcons/white/coordinatedturn-new-01.png';
import extBusImgWhite from '../../../../assets/lcpIcons/white/extbus.png';
import functionSetupImgWhite from '../../../../assets/lcpIcons/white/functionsetup-new-01.png';
import gpsSimImgWhite from '../../../../assets/lcpIcons/white/gpsselection-new-01.png';
import interceptorImgWhite from '../../../../assets/lcpIcons/white/interceptorsetup-01.png';
import nmeaSimImgWhite from '../../../../assets/lcpIcons/white/NMEA-R-Blue-293-x-214-compressed 2.png';
import systemSetupImgWhite from '../../../../assets/lcpIcons/white/panelsettings.png';
import rudderImgWhite from '../../../../assets/lcpIcons/white/ruddersignalnew-01.png';
import sensorImgWhite from '../../../../assets/lcpIcons/white/sensorsetup-01.png';
import speedImgWhite from '../../../../assets/lcpIcons/white/speedsource-01.png';
import pitchImgWhite from '../../../../assets/lcpIcons/white/waves-01.png';
import { useTheme } from '../../../../contexts/ThemeContext';
import { MenuVisibility } from '../../../../models/ApiModels';
import {
  presetVisibilityAdvancedData,
  presetVisibilityFunctionData,
  presetVisibilitySystemData,
} from '../../../DataExports/presetVisibilityData';

interface Props {
  data: MenuVisibility;
}

export default function ConfigurationVisibilitySettings(props: Props) {
  const { resolvedTheme } = useTheme();

  const visibilitySystem = presetVisibilitySystemData(props.data, {
    sensorImg: resolvedTheme === 'light' ? sensorImg : sensorImgWhite,
    signalImg: resolvedTheme === 'light' ? rudderImg : rudderImgWhite,
    setupImg: resolvedTheme === 'light' ? interceptorImg : interceptorImgWhite,
    speedImg: resolvedTheme === 'light' ? speedImg : speedImgWhite,
    extBusImg: resolvedTheme === 'light' ? extBusImg : extBusImgWhite,
  });

  const visibilityFunction = presetVisibilityFunctionData(props.data, {
    sensitivityImg: resolvedTheme === 'light' ? sensitivityImg : sensitivityImgWhite,
    autoTrimImg: resolvedTheme === 'light' ? autoTrimImg : autoTrimImgWhite,
    listImg: resolvedTheme === 'light' ? listImg : listImgWhite,
    coTurnImg: resolvedTheme === 'light' ? coTurnImg : coTurnImgWhite,
    pitchImg: resolvedTheme === 'light' ? pitchImg : pitchImgWhite,
  });

  const visibilityAdvanced = presetVisibilityAdvancedData(props.data, {
    nmeaSimImg: resolvedTheme === 'light' ? nmeaSimImg : nmeaSimImgWhite,
    gpsSimImg: resolvedTheme === 'light' ? gpsSimImg : gpsSimImgWhite,
  });

  // If no visibility settings are applied, return null to avoid displaying an empty section
  if (!Object.values(props.data).some(Boolean)) {
    return null;
  } else {
    return (
      <div className='flex-1'>
        <h4 className='prose-heading4 pb-6 mb-5 border-b border-gray-10'>Setting visibility</h4>
        <div className='flex justify-between border-b border-gray-10 py-4'>
          <div className='flex gap-1'>
            Setting unlock password
            <Tooltip
              heading='Setting unlock password'
              description='Use this password in the Advanced > Login menu in the LCP, to enable every setting to be set again. When the system restarts the settings will be hidden again.'
            />
          </div>
          <p>{props.data && props.data.password}</p>
        </div>
        <div className='flex flex-wrap gap-20 mt-10 pb-10 border-b border-gray-10'>
          <div>
            <h5 className='prose-heading5 pb-4'>
              <img
                src={resolvedTheme === 'light' ? systemSetupImg : systemSetupImgWhite}
                className='h-6 inline mr-1 object-contain'
                alt='system visibility'
              />
              System visibility
            </h5>
            {props.data !== undefined &&
              visibilitySystem.map((item) => {
                return (
                  <div className='flex items-center gap-2 my-2' key={item.key}>
                    <img src={item.img} className={`${!item.value ? 'opacity-100' : 'opacity-40'}`} alt={item.key} />
                    <h6 className={`prose-heading6 flex-1 ${!item.value ? 'text-black' : 'text-gray-40'}`}>
                      {item.key}
                    </h6>
                    {!item.value ? (
                      <FontAwesomeIcon icon={faEye} className='w-8' />
                    ) : (
                      <FontAwesomeIcon icon={faEyeSlash} className='w-8 text-gray-40' />
                    )}
                  </div>
                );
              })}
          </div>
          <div>
            <h5 className='prose-heading5 pb-4'>
              <img
                src={resolvedTheme === 'light' ? functionSetupImg : functionSetupImgWhite}
                className='h-6 inline mr-1 /object-contain'
                alt='function visibility'
              />
              Function visibility
            </h5>
            {props.data !== undefined &&
              visibilityFunction.map((item) => {
                return (
                  <div className='flex items-center gap-2 my-2' key={item.key}>
                    <img src={item.img} className={`${!item.value ? 'opacity-100' : 'opacity-40'}`} alt={item.key} />
                    <h6 className={`prose-heading6 flex-1 ${!item.value ? 'text-black' : 'text-gray-40'}`}>
                      {item.key}
                    </h6>
                    {!item.value ? (
                      <FontAwesomeIcon icon={faEye} className='w-8' />
                    ) : (
                      <FontAwesomeIcon icon={faEyeSlash} className='w-8 text-gray-40' />
                    )}
                  </div>
                );
              })}
          </div>
          <div>
            <h5 className='prose-heading5 pb-4'>
              <img
                src={resolvedTheme === 'light' ? advancedMenusImg : advancedMenusImgWhite}
                className='h-6 inline mr-1 /object-contain'
                alt='advanced menus'
              />
              Advanced menus
            </h5>
            {props.data !== undefined &&
              visibilityAdvanced.map((item) => {
                return (
                  <div className='flex items-center gap-2 my-2' key={item.key}>
                    <img src={item.img} className={`${!item.value ? 'opacity-100' : 'opacity-40'}`} alt={item.key} />
                    <h6 className={`prose-heading6 flex-1 ${!item.value ? 'text-black' : 'text-gray-40'}`}>
                      {item.key}
                    </h6>
                    {!item.value ? (
                      <FontAwesomeIcon icon={faEye} className='w-8' />
                    ) : (
                      <FontAwesomeIcon icon={faEyeSlash} className='w-8 text-gray-40' />
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    );
  }
}
